export const colors = {
  earthBrown50: "#f5ede4",
  earthBrown100: "#ebd9c9",
  earthBrown200: "#d7b393",
  earthBrown300: "#c38e5d",
  earthBrown400: "#af6827",
  earthBrown500: "#8b4513",
  earthBrown600: "#7e3e11",
  earthBrown700: "#6e3610",
  earthBrown800: "#5f2f0e",
  earthBrown900: "#4f270c",
  mossGreen50: "#f0f4ec",
  mossGreen100: "#dce5d2",
  mossGreen200: "#b9cba5",
  mossGreen300: "#97b078",
  mossGreen400: "#74964b",
  mossGreen500: "#556b2f",
  mossGreen600: "#4d602a",
  mossGreen700: "#435425",
  mossGreen800: "#3a491f",
  mossGreen900: "#303d1a",
  sunsetOrange50: "#fff0e6",
  sunsetOrange100: "#ffe0cc",
  sunsetOrange200: "#ffc199",
  sunsetOrange300: "#ffa366",
  sunsetOrange400: "#ff844d",
  sunsetOrange500: "#ff4500",
  sunsetOrange600: "#e63e00",
  sunsetOrange700: "#cc3800",
  sunsetOrange800: "#b33200",
  sunsetOrange900: "#992b00",
  skyBlue50: "#f0faff",
  skyBlue100: "#e1f5ff",
  skyBlue200: "#c3ebff",
  skyBlue300: "#a4e0ff",
  skyBlue400: "#86d6ff",
  skyBlue500: "#5bb9e5",
  skyBlue600: "#4da5ce",
  skyBlue700: "#3f90b7",
  skyBlue800: "#317ca0",
  skyBlue900: "#236789",
  neutral50: "#fafafa",
  neutral100: "#f5f5f5",
  neutral200: "#eeeeee",
  neutral300: "#e0e0e0",
  neutral400: "#bdbdbd",
  neutral500: "#9e9e9e",
  neutral600: "#757575",
  neutral700: "#616161",
  neutral800: "#424242",
  neutral900: "#212121",
  white: "#ffffff",
  black: "#000000",
};
